import TopicOfInterestBlock from './TopicOfInterestBlock';

export default TopicOfInterestBlock;
